import * as Business   from '../business';
import * as ENV        from '../util/env';
import * as User       from '../user';
import { connect }     from 'react-redux';
import React           from 'react';
import TabPage         from '../components/tab_page';
import TabPageLink     from '../components/tab_page_link';

import CallsIcon       from '../assets/icons/calls.svg';
import DataSourcesIcon from '../assets/icons/data_sources.svg';
import MessagingIcon   from '../assets/icons/messaging.svg';
import StorefrontIcon  from '../assets/icons/storefront.svg';
import TeamIcon        from '../assets/icons/team.svg';
import WebchatIcon     from '../assets/icons/webchat.svg';


export default connect(
  (state, { businessID, path }) => ({
    business:                   Business.getBusiness(state, businessID),
    paymentsSettings:           Business.getPaymentsSettings(state, businessID),
    isAdmin:                    User.isAdmin(state, businessID),
    isManager:                  User.isManager(state, businessID),
    canChangeOnlineProfiles:    User.canChangeOnlineProfiles(state, businessID),
    callSettings:               User.getCallSettings(state),
    twilioNumber:               Business.getConnectedPhoneNumber(state, businessID),
    googleLocationBadgeCount:   Business.getGoogleLocationBadgeCount(state, businessID),
    facebookLocationBadgeCount: Business.getFacebookLocationBadgeCount(state, businessID),
    path
  })
)(SettingsTab);


export function SettingsTab({
  tabActive,
  business,
  isAdmin,
  isManager,
  canChangeOnlineProfiles,
  callSettings,
  paymentsSettings,
  twilioNumber,
  googleLocationBadgeCount,
  facebookLocationBadgeCount
}) {
  return (
    <TabPage name="settings" title="Preferences">
      <div className="page-content">
        {business && (
          <TabLinks {...{
            tabActive,
            isAdmin,
            isManager,
            canChangeOnlineProfiles,
            callSettings,
            business,
            paymentsSettings,
            twilioNumber,
            googleLocationBadgeCount,
            facebookLocationBadgeCount
          }}/>
        )}
      </div>
    </TabPage>
  );
}


function TabLinks({
  tabActive,
  isAdmin,
  isManager,
  canChangeOnlineProfiles,
  business,
  callSettings,
  paymentsSettings,
  twilioNumber,
  googleLocationBadgeCount,
  facebookLocationBadgeCount
}) {
  const isPaymentsAvailable       = paymentsSettings?.available;
  const isPaymentsEnabled         = paymentsSettings?.enabled;
  const isPaymentsLiveMode        = paymentsSettings?.liveMode;
  const showCallsPage             = (!!twilioNumber) && ENV.isWeb() && callSettings;
  const showPaymentsPage          = isPaymentsAvailable && isAdmin;
  const profilesNotificationCount = googleLocationBadgeCount + facebookLocationBadgeCount;

  return (
    <div className="list media-list">
      <ul>
        {canChangeOnlineProfiles && (
          <TabPageLink
            active={tabActive === 'BusinessProfile'}
            href={`/${business.id}/settings/business_profile`}
            badgeCount={profilesNotificationCount}
            title="Online Profiles"
            subtitle="Connect to Google, Facebook, and more"
            icon={<StorefrontIcon/>}
          />
        )}
        {isAdmin && (
          <TabPageLink
            active={[ 'ManageTeam', 'InviteUser', 'ViewUser' ].includes(tabActive)}
            href={`/${business.id}/settings/team`}
            title="Team"
            icon={<TeamIcon/>}>
            {`${(business.users || []).length} Active`}
          </TabPageLink>
        )}
        {isAdmin && (
          <TabPageLink
            active={tabActive === 'SettingsMessaging' || tabActive === 'HostedNumber'}
            href={`/${business.id}/settings/messaging`}
            title="Messaging"
            icon={<MessagingIcon/>}>
            <Messaging business={business}/>
          </TabPageLink>
        )}
        {showCallsPage && (
          <TabPageLink
            active={tabActive === 'SettingsCalls'}
            href={`/${business.id}/settings/calls`}
            title="Calls"
            icon={<CallsIcon/>}>
            <Calls callSettings={callSettings}/>
          </TabPageLink>
        )}
        {(isAdmin || isManager) && (
          <TabPageLink
            active={tabActive === 'WebChat'}
            href={`/${business.id}/settings/webchat`}
            title="Web Chat"
            icon={<WebchatIcon/>}>
            <WebChat business={business}/>
          </TabPageLink>
        )}
        {isAdmin && (
          <TabPageLink
            active={[ 'DataSources', 'DataSourcesConfigure' ].includes(tabActive)}
            href={`/${business.id}/settings/data_sources`}
            title="Data Sources"
            subtitle="Manage and add data sources"
            icon={<DataSourcesIcon/>}/>
        )}
        {showPaymentsPage && (
          <TabPageLink
            active={tabActive === 'PaymentsSettings'}
            href={`/${business.id}/settings/payments`}
            title="Payments"
            icon={<i className="f7-icons invoices-icon">money_dollar</i>}>
            <Payments {...{ isPaymentsEnabled, isPaymentsLiveMode }}/>
          </TabPageLink>
        )}
      </ul>
    </div>
  );
}


function WebChat({ business }) {
  const { chat } = business.settings;
  const enabled  = chat?.enabled;
  return enabled ? 'Enabled' : 'Disabled';
}


function Messaging({ business }) {
  const { twilio } = business.settings;
  const followUp   = twilio?.followUp;
  return followUp ? 'SMS follow up' : 'No SMS follow up';
}


function Payments({ isPaymentsEnabled, isPaymentsLiveMode }) {
  if (isPaymentsEnabled)
    return isPaymentsLiveMode  ? 'Payments Enabled' : 'Payments Enabled in Test Mode';
  else
    return 'Payments Disabled';
}


const devices = {
  browser: 'computer',
  phone:   'phone'
};


function Calls({ callSettings: { incoming, device } }) {
  const deviceDisplayName = devices[device] || device;
  if (incoming)
    return `Accept calls, use ${deviceDisplayName}`;
  else
    return `Use ${deviceDisplayName}`;
}
